import { render, staticRenderFns } from "./ExpenseDefaultPricingTableReadOnly.vue?vue&type=template&id=9ec96472&scoped=true&"
import script from "./ExpenseDefaultPricingTableReadOnly.vue?vue&type=script&lang=js&"
export * from "./ExpenseDefaultPricingTableReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDefaultPricingTableReadOnly.vue?vue&type=style&index=0&id=9ec96472&lang=scss&scoped=true&"
import style1 from "./ExpenseDefaultPricingTableReadOnly.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ExpenseDefaultPricingTableReadOnly.vue?vue&type=style&index=2&id=9ec96472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec96472",
  null
  
)

export default component.exports